import React from "react";
import { Autocomplete, Grid, TextField, Typography, Box } from "@mui/material";
import Item from "./DashboardStyle";
import DateTab from "pages/date/Date";
import LocationDropdown from "components/LocationDropdown/LocationDropdown";
import CommonSDF from "components/commonSDF/CommonSdf";
import { setSelectedLocation } from "redux/actions/LocationDropdown";

const DashboardHeader = (props) => {
  // Define the data to be used based on the role
  const data = props?.dashboardData;
  // console.log("userProfileData---->", props.userProfileData)
  // console.log(" dashh Location---->", props.Location);

  const handleLocationChange = (location) => {
    console.log( 'Location changed:', location);
    props.onInputChange(location);
  };

  const onRedirectPage = (e, data) => {
    props?.onRedirectPage(data);
  };

  const dashHeader = (i, data) => {
    if (i === 0) {
      return "dashboardHeadStart dashboardBorder";
    } else if (i === data.length - 1) {
      return "dashboardHeadEnd dashboardBorder";
    } else {
      return "dashboardHead dashboardBorder";
    }
  };

  const dashSection = (i, data) => {
    if (i === 0) {
      return "dashboardSectionStart dashboardSection dashboardBorder";
    } else if (i === data.length - 1) {
      return "dashboardSectionEnd dashboardSection dashboardBorder";
    } else {
      return "dashboardSection dashboardBorder";
    }
  };

  return (
    <div>
<Grid
  container
  direction="row"
  alignItems="center"
  className="marginTop15"
  spacing={{ xs: 1 }}
>
  {/* Trip Report Title */}
  <Grid item lg={2} md={4} sm={4} xs={12}>
    <Typography className="fontMedium colorBlack font18">
      Trip Details
    </Typography>
  </Grid>

  {/* Location + Calendar in one row */}
  <Grid
    item
    lg={10}
    md={8}
    sm={8}
    xs={12}
  >
    <Grid
      container
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      spacing={2}
    >
      {/* Location Dropdown */}
      <Grid item>
        <Box sx={{ minWidth: 200, maxWidth: 250 }}>
          <LocationDropdown
            onChange={handleLocationChange}
            className="location-dropdown"
          />
        </Box>
      </Grid>

      {/* Calendar */}
      <Grid item>
        <CommonSDF
          onSelectDateRange={props?.onSelectDateRange}
          tabName={props?.tabName}
          dateFrom={props?.dateFrom}
          dateTo={props?.dateTo}
        />
      </Grid>
    </Grid>
  </Grid>
</Grid>


      <Box sx={{ marginTop: 2 }}>
        <Grid container className="dashboard_main">
          {data?.map((ele, i) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={ele.id}
              className={`dashboardCard dashboaardCard${i + 1}
                  ${ele?.title === "Tickets" ? "cursorDefault" : "cursor"}`}
              // onClick={(e) => {onRedirectPage(e,ele)}}
            >
              <Item className={`dashboardCardContents`}>
                <Grid
                  item
                  content
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  className="dflex"
                >
                  <Grid iten>
                    <h1 className="font16 fontNormal marginBlock colorBlack">
                      {ele.title}
                    </h1>
                  </Grid>
                </Grid>
                <h1 className="fontSemi font20 marginBlock colorBlack">
                  {ele.ridenumber}{" "}
                  <span className="font12 colorGrey fontNormal marginInline10">
                    {ele.rental}
                  </span>
                </h1>
                <h1 className="fontMedium font20 marginBlock colorBlack">
                  {ele.cabnumber}{" "}
                  <span className="font12 colorGrey fontNormal marginInline10">
                    {ele.schedule}
                  </span>
                </h1>
              </Item>
            </Grid>
          ))}
        </Grid>
      </Box>
    </div>
  );
};

export default DashboardHeader;
